let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("biCSR")).then(() => parcelRequire('fgmtQ'));